// Note: This is a temporary implementation of custom no result search icon.
// We should be able to update the default DawnSearchIcon after the refactoring
// Allowing it to scale gracefully while maintaining the stroke width
// TODO: Remove this after the refactoring of icons

import { SvgStroke } from '@xemplo/style-constants';

export const NoResultSearchIcon = () => {
  return (
    <svg
      width={65}
      height={65}
      viewBox="0 0 65 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M42.7901 42.7904L56.5 56.5M48.0655 28.2829C48.0655 39.2087 39.2084 48.0659 28.2827 48.0659C17.357 48.0659 8.5 39.2087 8.5 28.2829C8.5 17.3571 17.357 8.5 28.2827 8.5C39.2084 8.5 48.0655 17.3571 48.0655 28.2829Z"
        stroke="#DCDFEA"
        strokeWidth={SvgStroke.Bold}
        strokeLinecap="round"
      />
    </svg>
  );
};
